import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 md:mt-24 bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg">
                <i className="ri-play-circle-fill"></i>
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">靠逼视频</span>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed">
              一个专注娱乐、生活、搞笑等多类别高清视频的内容聚合与分享平台，让每一次观看都轻松有趣。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              <Link to="/category/entertainment">视频分类</Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/category/${c.id}`}
                    className="text-sm text-foreground-700 hover:text-primary-400 transition-colors"
                  >
                    {c.name}视频
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              <Link to="/">快速导航</Link>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-700 hover:text-primary-400 transition-colors">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-foreground-700 hover:text-primary-400 transition-colors">
                  视频搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-700 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-700 hover:text-primary-400 transition-colors">
                  使用与隐私说明
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              <Link to="/about">联系我们</Link>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line text-accent-400"></i>
                hello@kaobivideo.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-customer-service-2-line text-accent-400"></i>
                工作日 09:00 - 18:00 在线
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-youtube-line'].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© {year} 靠逼视频 · 本站内容均为演示数据，仅供学习与体验。</p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            <Link to="/about" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors">
              隐私保护
            </Link>
            <Link to="/about" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors">
              免责声明
            </Link>
            <Link to="/about" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors">
              友情链接
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}